module.exports = require('./some');



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/collection/any.js
 ** module id = 399
 ** module chunks = 0
 **/